export default "__VITE_ASSET__488d46f6__"